import ToggleVisibility from "../Recursion/ToggleVisibilityRecursion";
import Recursion from '../Recursion/Recursion'
import "../../Paths/Problems.css";

export default function App() {
  return (
    <div className="App">
      <ToggleVisibility>
        <Recursion/>
      </ToggleVisibility>
    </div>
  );
}